import React from 'react'
import T from 'prop-types'
import { Box, Divider, Paper, Typography } from '@mui/material'

import ChoicesRecap from './ChoicesRecap'
import CarCardChoices from './CarCardChoices'
import CarBlindPrice from './CarBlindPrice'
import CarReprice from './CarReprice'
export default function CarsToBuyCarDetailsRightBottom({
  session,
  partnerId,
  cars,
  caps,
  car,
  selectedChoices,
  disabledChoices,
  selection = 'none',
  onSelectionChange = () => {},
  handleConfirmReprice = () => {},
  handleConfirmBlindPrice = () => {},
  canReprice,
  readOnly,
  showNotice = true,
  showNonBlindReprice,
  showBlindPrice = false,
  blindReadOnly = false,
  blindOffersRemaining,
  showBlindOption = false,
  showBlindPositiveSignal = true,
  showBlindPositiveOffers = true,
  showBlindConfirmButton = true,
  repairHintText,
  showRepairBlindHint = false,
}) {
  const resolvedShowNonBlindReprice =
    typeof showNonBlindReprice === 'boolean' ? showNonBlindReprice : canReprice

  return (
    <Box mt={2}>
      <Paper>
        <Box p={2}>
          <ChoicesRecap
            variant="details"
            cars={cars}
            caps={caps}
            showBlindPositiveOffers={showBlindPositiveOffers}
          />
          {repairHintText && (
            <Typography
              variant="body2"
              color="primaryText"
              sx={{ pt: 1 }}
              data-testid="cars-to-buy-details-repair-hint"
            >
              {repairHintText}
            </Typography>
          )}
        </Box>
        <Divider sx={{ my: 1 }} />
        <Box p={2}>
          <CarCardChoices
            session={session}
            partnerId={partnerId}
            variant="details"
            car={car}
            disabledChoices={disabledChoices}
            blindOffersRemaining={blindOffersRemaining}
            selectedChoices={selectedChoices}
            readOnly={readOnly}
            selection={selection}
            onSelectionChange={onSelectionChange}
            showBlindOption={showBlindOption}
            showBlindPositiveSignal={showBlindPositiveSignal}
          />
          {resolvedShowNonBlindReprice && (
            <CarReprice
              variant="details"
              car={car}
              handleConfirmReprice={handleConfirmReprice}
              readOnly={readOnly}
            />
          )}
          {showBlindPrice && (
            <CarBlindPrice
              variant="details"
              car={car}
              handleConfirmBlindPrice={handleConfirmBlindPrice}
              readOnly={blindReadOnly}
              showConfirmButton={showBlindConfirmButton}
              enabled={selection === 'blind'}
              blindOffersRemaining={blindOffersRemaining}
              allowBlindPositiveOffers={showBlindPositiveOffers}
              showRepairHint={showRepairBlindHint}
            />
          )}
        </Box>
        {car && car.publicAdvice && (
          <>
            <Divider sx={{ my: 1 }} />
            <Box p={2}>
              <Typography
                variant="body2"
                color="primaryText"
                sx={{ pb: 1 }}
                data-testid="choices-recap-details-title"
              >
                <strong>{'Avviso'}</strong>
              </Typography>
              <Typography color="error">{car.publicAdvice}</Typography>
            </Box>
          </>
        )}
      </Paper>
    </Box>
  )
}

CarsToBuyCarDetailsRightBottom.propTypes = {
  session: T.object.isRequired,
  partnerId: T.string,
  car: T.object.isRequired,
  cars: T.array.isRequired,
  caps: T.object.isRequired,
  selectedChoices: T.object,
  disabledChoices: T.object,
  selection: T.string,
  onSelectionChange: T.func,
  handleConfirmReprice: T.func,
  handleConfirmBlindPrice: T.func,
  canReprice: T.bool,
  readOnly: T.bool,
  showNotice: T.bool,
  showNonBlindReprice: T.bool,
  showBlindPrice: T.bool,
  blindReadOnly: T.bool,
  blindOffersRemaining: T.oneOfType([
    T.number,
    T.shape({
      positive: T.number,
      negative: T.number,
    }),
  ]),
  showBlindOption: T.bool,
  showBlindPositiveSignal: T.bool,
  showBlindPositiveOffers: T.bool,
  showBlindConfirmButton: T.bool,
  repairHintText: T.string,
  showRepairBlindHint: T.bool,
}
